import "~/misc/common";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
	connect() {
		console.log('initUsersIndex');
		$('#modalMail').on('shown.bs.modal', function () {
			$.get('/users/email.json' + location.search, function (data) {
				$('#emails').text(data.join('; '));
				$('#emails').select();
			});
		});
	}
}
